module.exports = __webpack_public_path__ + "static/media/cellphone-buy.10ba0a04.png";